module.exports = __webpack_public_path__ + "static/media/dust_scratches.608ab5fe.png";